var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:_vm.classList,attrs:{"data-vv-scope":_vm.id,"novalidate":""},on:{"submit":function($event){$event.preventDefault();_vm.validateForm()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }